/**
 * Path to the federation manifest loaded by initFederation() in main.ts.
 *
 * This is a standalone file (no imports from shared libraries) because it is
 * imported BEFORE initFederation() completes. Any import from a shared
 * federation module (e.g. @share_it/foundation-core) at this stage would
 * break the bootstrap with a blank screen.
 *
 * For local development, angular.json esbuild:local replaces this file with
 * federation-manifest-path.local.ts which points to the generated
 * federation.manifest.local.json.
 */
export const federationManifestPath = 'assets/federation.manifest.json';
